interface ToastMessage {
  title: string;
  description: string;
  variant?: "default" | "destructive";
}

interface ExportExcelMessages {
  NO_STORE: ToastMessage;
  SUCCESS: ToastMessage;
  ERROR: ToastMessage;
}

export const EXPORT_EXCEL_MESSAGES: ExportExcelMessages = {
  NO_STORE: {
    title: "Erro",
    description: "Selecione uma loja para exportar",
    variant: "destructive",
  },
  SUCCESS: {
    title: "Sucesso",
    description: "Excel exportado com sucesso!",
  },
  ERROR: {
    title: "Erro",
    description: "Erro ao exportar Excel. Tente novamente.",
    variant: "destructive",
  },
};
